import { Button, HStack, VStack } from "@chakra-ui/react";
import { yupResolver } from "@hookform/resolvers/yup";
import { InputTextArea } from "components/Atomos/Form/Elements/InputTextArea";
import { useForm } from "react-hook-form";
import { useAppDispatch, useTypedSelector } from "store/hooks";
import { adicionarMensagem } from "store/modules/ouvidoria/manifestacoes/actions/adicionarMensagem";
import * as yup from "yup";

export const commentSchema = yup.object().shape({
  comment: yup
    .string()
    .required()
    .min(3, "O comentário deve possuir mais que 3 caracteres.")
});

export type CommentFormData = {
  comment: string;
};

type CommentFormProps = {
  idManifestacao: string;
  onSuccess: (data: CommentFormData) => void;
  onClose: () => void;
};

const CommentForm = ({
  idManifestacao,
  onSuccess,
  onClose
}: CommentFormProps) => {
  const dispatch = useAppDispatch();
  const isRequesting = useTypedSelector(
    (state) => state.ouvidoria.manifestacoes.adicionarMensagem.isRequesting
  );

  const { register, handleSubmit } = useForm<CommentFormData>({
    resolver: yupResolver(commentSchema)
  });

  const onSubmit = async (data: CommentFormData) => {
    dispatch(
      adicionarMensagem({
        idManifestacao,
        texto: data.comment,
        onSuccess: () => onSuccess(data)
      })
    );
  };

  return (
    <VStack spacing={4} as="form" onSubmit={handleSubmit(onSubmit)}>
      <InputTextArea
        label="Escreva uma resposta"
        register={register}
        name="comment"
        rows={5}
      />
      <HStack spacing={2} w="full">
        <Button type="submit" variant="main" isLoading={isRequesting}>
          Responder
        </Button>
        <Button variant="ghost" onClick={onClose}>
          Cancelar
        </Button>
      </HStack>
    </VStack>
  );
};
export { CommentForm };
